import React, {Component} from 'react'
import {Field} from 'formik';
import PropTypes from 'prop-types';

export default class Select extends Component
{

	static propTypes = {
		name: PropTypes.string.isRequired
	};

	render() {
		return (
			<Field name={this.props.name}>
				{({field, form}) => (
					<input
						type="checkbox"
						className="form-check-input"
						checked={field.value}
						onChange={() => form.setFieldValue(this.props.name, !field.value)}
					/>
				)}
			</Field>
		);
	};
}


// WEBPACK FOOTER //
// ./React/src/components/form/Checkbox.js